export default __webpack_public_path__ + "static/goods-book-2c5805b7575f24437a11f18a02add15e.png";